export const sortOptions = [
  { label: "Newest", value: "newest", prefix: "Sort By" },
  { label: "Oldest", value: "oldest", prefix: "Sort By" },
  { label: "Status", value: "status", prefix: "Sort By" },
  { label: "Name", value: "name", prefix: "Sort By" }
];
